<template>
  <div>
    <BaseHeader title="開発テスト用" />
    <h3>API</h3>
    現在時刻 ：{{ Math.floor(date / 1000) }}<br>
    有効期限 ：{{ tokenExp }}<br>
    リフ期限 ：{{ refreshTokenExp }}<br>
    <div class="button-group">
      <el-button @click="auth">認証</el-button>
      <el-button @click="refresh">リフレッシュ</el-button>
      <el-button @click="checkTokenExp">トークンチェック</el-button>
    </div>
    <div class="button-group api">
      <el-row :gutter="5">
        <el-col :span="4">
          <el-button @click="graphQlCustomerList">GraphQL(CustomerList)</el-button>
        </el-col>
        <el-col :span="4">
          <el-button @click="graphQlAccountList">GraphQL(AccountList)</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :span="4">
          <el-button @click="graphQlSiteRoleList">GraphQL(SiteRole一覧)</el-button>
        </el-col>
        <el-col :span="4">
          <el-button @click="graphQlSiteRoleDetail">GraphQL(SiteRole詳細)</el-button>
        </el-col>
        <el-col :span="4">
          <el-button @click="graphQlPermissionRoleList">GraphQL(PermissionRole一覧)</el-button>
        </el-col>
        <el-col :span="4">
          <el-button @click="graphQlPermissionRoleDetail">GraphQL(PermissionRole詳細)</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="button-group">
      <el-button @click="getPoint">ポイント取得</el-button>
      <el-button @click="postPoint">ポイント付与・利用</el-button>
      <el-button @click="postPointByOrder">ポイント計算</el-button>
    </div>
    <div class="button-group">
      <el-button @click="orderUpdate">注文更新</el-button>
    </div>
    <div class="button-group">
      <el-button @click="postNote">注文記録登録</el-button>
      <el-button @click="putNote">注文記録更新</el-button>
      <el-button @click="deleteNote">注文記録削除</el-button>
    </div>
    <div class="button-group">
      <el-button @click="orderExport">出荷指図登録</el-button>
      <el-button @click="orderExportCancel">出荷指図キャンセル</el-button>
    </div>
    <div class="button-group">
      <el-button @click="deleteAccount">アカウント削除</el-button>
      <el-button @click="putPassword">パスワード更新</el-button>
    </div>
    <div class="button-group">
      <el-button @click="postRoleSite">サイトロール登録</el-button>
      <el-button @click="putRoleSite">サイトロール更新</el-button>
      <el-button @click="postRolePermission">権限ロール登録</el-button>
      <el-button @click="putRolePermission">権限ロール更新</el-button>
      <el-button @click="deleteRole">ロール削除</el-button>
    </div>
    <div class="button-group">
      <el-button @click="payment">支払処理</el-button>
    </div>
    <div>
      <pre>{{ _response }}</pre>
    </div>
    <el-button @click="testMakeOrderRequest">注文更新リクエスト作成テスト</el-button>
  </div>
</template>

<style scoped>
div.button-group.api {
  min-width: 1000px;
}
div.button-group {
  padding: 2.5px 0;
}
.el-row .el-button {
  width: 100%;
}
</style>

<script>
import { mapState } from 'vuex'
import * as config from '@/config'
import common from '@/utils/common'
import compare from '@/utils/compareUtils'
import auth from '@/utils/auth'
import * as gqlAccount from '@/queries/account'
import * as gqlSiteRole from '@/queries/siteRole'
import * as gqlPermissionRole from '@/queries/permissionRole'
import * as gqlCustomer from '@/queries/customer'

import BaseHeader from '@/components/molecules/BaseHeader'

export default {
  name: 'ForTest',
  filters: {
  },
  components: {
    BaseHeader
  },
  data () {
    return {
      date: null,
      response: null
    }
  },
  computed: {
    ...mapState({
      token: (state) => state.token,
      tokenExp: (state) => state.tokenExp,
      refreshToken: (state) => state.refreshToken
    }),
    refreshTokenExp () {
      return JSON.parse(window.atob(this.refreshToken.split('.')[1])).exp
    },
    _response () {
      return JSON.stringify(this.response, null, 2)
    }
  },
  watch: {
  },
  created () {
  },
  beforeUpdate () {
  },
  mounted () {
    setInterval(() => { this.date = new Date() }, 1000)
  },
  methods: {
    async auth () {
      // const id = 'ccs@businet-s.co.jp';
      // const password = 'ccs@businet-s.co.jp';
      const id = 'sasaki'
      const password = 'sasaki'
      await auth.auth(id, password, 'abcd')
    },
    async refresh () {
      await auth.refresh()
    },
    async checkTokenExp () {
      try {
        await auth.tokenExpiredTransitionLogin()
      } catch (error) {
        return false
      }
      console.log('checkToken-end')
    },
    async graphQlCustomerList () {
      this.graphQl(gqlCustomer.GRAPH_QL_QUERY_CUSTOMER_LIST)
    },
    async graphQlAccountList () {
      this.graphQl(gqlAccount.GRAPH_QL_QUERY_ACCOUNT_LIST)
    },
    async graphQlSiteRoleList () {
      this.graphQl(gqlSiteRole.GRAPH_QL_QUERY_SITE_ROLE_LIST)
    },
    async graphQlSiteRoleDetail () {
      this.graphQl(gqlSiteRole.GRAPH_QL_QUERY_SITE_ROLE_DETAIL)
    },
    async graphQlPermissionRoleList () {
      this.graphQl(gqlPermissionRole.GRAPH_QL_QUERY_PERMISSION_ROLE_LIST)
    },
    async graphQlPermissionRoleDetail () {
      this.graphQl(gqlPermissionRole.GRAPH_QL_QUERY_PERMISSION_ROLE_DETAIL)
    },
    async graphQl (query) {
      console.log(query)
      try {
        this.$loadingService.show()
        try {
          const res = await common.postGraphQl(query)
          this.response = res
        } catch (error) {
          if (error.response.status === 403) {
            try {
              await this.refresh()
              await this.graphQl(query)
            } catch (error) {
              this.$store.dispatch({
                type: 'set',
                states: {
                  'loggedIn': false
                }
              })
              this.$router.push({ path: '/login', query: { redirect: this.$router.history.current.path } })
            }
          }
        }
      } finally {
        this.$loadingService.close()
      }
    },
    async callApi (url, data) {
      try {
        this.$loadingService.show()
        this.response = await common.apiAxios(url, data)
      } catch (error) {
        this.response = error
      } finally {
        this.$loadingService.close()
      }
    },
    getPoint () {
      this.callApi(config.POINT_URL + '/AGL/1001',
        {
          method: 'get',
          data: {}
        })
    },
    postPoint () {
      this.callApi(config.POINT_URL,
        {
          method: 'post',
          data: {
            'gcd': 'AGL',
            'cno': '1001',
            'point': 100,
            'type': 1,
            // 'limit': 1,
            // 'expire': '2018-09-30T23:59:59+09:00',
            'reason': '020',
            'note': 'バースデイポイント'
          }
        })
    },
    postPointByOrder () {
      this.callApi(config.POINT_BY_ORDER_URL,
        {
          method: 'post',
          data: {
            'gcd': 'BD',
            'cno': '1234-5678-9012',
            'orderDatetime': '2018-09-03 15:17:25+09:00',
            'items': [
              {
                'itemType': '1',
                'productId': '0179782001-S-010',
                'isSale': 0,
                'isPreorder': 0,
                'price': {
                  'net': '1000',
                  'tax': 80
                },
                'priceAdjustment': {
                  'net': -100,
                  'tax': '-8'
                }
              },
              {
                'itemType': '1',
                'productId': '0179782002-S-010',
                'isSale': 1,
                'isPreorder': 0,
                'price': {
                  'net': '3000',
                  'tax': 240
                }
              }
            ],
            'priceAdjustment': {
              'net': -200,
              'tax': '-16'
            },
            'promotionCode': 'XYZ',
            'applyDate': '2018-09-05 0:00:00+09:00',
            'apply': 0
          }
        })
    },
    orderUpdate () {
      const data = {
        site: {
          code: '16330'
        },
        qty: {
          current: 100
        }
      }
      const uuid = 'b1a1d341-4133-4c65-b7fa-8dc7f32e5416'
      this.callApi(config.ORDER_URL + '/' + uuid + '/edit',
        {
          method: 'put',
          data: data
        })
    },
    postNote () {
      this.callApi(config.ORDER_NOTE_URL,
        {
          method: 'post',
          data: {
            siteCode: '16330',
            orderNo: 'CCS00000000001',
            subject: '件名XXX',
            note: '記録内容XXX',
            noteType: 0
          }
        })
    },
    putNote () {
      this.callApi(config.ORDER_NOTE_URL + '/f8cbc5c0-f3b9-11e8-822c-06f083b99fca',
        {
          method: 'put',
          data: {
            subject: '件名XXX new',
            note: '記録内容XXX new'
          }
        })
    },
    deleteNote () {
      this.callApi(config.ORDER_NOTE_URL + '/f8cbc5c0-f3b9-11e8-822c-06f083b99fca',
        {
          method: 'delete'
        })
    },
    orderExport () {
      // const data = {siteCode: '16330', orderNo: 'CCSBD00000119', items:[{position: 1, quantity: 0, exportType: 1}]}
      const data = {
        'siteCode': '16330',
        'orderNo': 'CCSBD00000104',
        'items': [
          { 'position': 1, 'quantity': 2, 'exportType': 3 },
          { 'position': 2, 'quantity': 1, 'exportType': 1, 'productId': 'SKU00002' }
        ],
        'exportableAt': '2018-12-04 07:56:11'
      }
      this.callApi(config.ORDER_EXPORT_URL,
        {
          method: 'post',
          data: data
        })
    },
    deleteAccount () {
      this.callApi(config.ACCOUNT_URL + '/f8cbc5c0-f3b9-11e8-822c-06f083b99fca', { method: 'delete' })
    },
    putPassword () {
      const data = {
        'current': 'j9cVfB3rM42D2CmL',
        'password': 'o7lzWwX6rbWVpEzw'
      }
      this.callApi(config.ACCOUNT_URL + '/f8cbc5c0-f3b9-11e8-822c-06f083b99fca' + '/password',
        { method: 'put', data: data })
    },
    postRoleSite () {
      const data = {
        'name': '自社ECサイト',
        'sites': [
          { 'code': '16120' },
          { 'code': '16330' }
        ]
      }
      this.callApi(config.ROLE_SITE_URL, { method: 'post', data: data })
    },
    putRoleSite () {
      const data = {
        'name': '自社ECサイト',
        'sites': [
          { 'code': '16120' },
          { 'code': '16330' }
        ]
      }
      this.callApi(config.ROLE_SITE_URL + '/f8cbc5c0-f3b9-11e8-822c-06f083b99fca',
        { method: 'put', data: data })
    },
    postRolePermission () {
      const data = {
        'name': '注文閲覧権限',
        'permissions': [
          { 'key': 'order.list', 'value': 1 },
          { 'key': 'inventory.upload', 'value': 0 },
          { 'key': 'account.list' }
        ]
      }
      this.callApi(config.ROLE_PERMISSION_URL, { method: 'post', data: data })
    },
    putRolePermission () {
      const data = {
        'name': '注文閲覧権限',
        'permissions': [
          { 'key': 'order.list', 'value': 1 },
          { 'key': 'inventory.upload', 'value': 0 },
          { 'key': 'account.list' }
        ]
      }
      this.callApi(config.ROLE_PERMISSION_URL + '/f8cbc5c0-f3b9-11e8-822c-06f083b99fca',
        { method: 'put', data: data })
    },
    deleteRole () {
      this.callApi(config.ROLE_URL + '/f8cbc5c0-f3b9-11e8-822c-06f083b99fca', { method: 'delete' })
    },
    orderExportCancel () {
      this.callApi(config.ORDER_EXPORT_URL + '/UUID',
        {
          method: 'delete'
        })
    },
    payment () {
      const data = { uuid: '1906fc0a-5890-46a2-a5f5-faf9db1ebe66' }
      this.callApi(config.PAYMENT_URL,
        {
          method: 'post',
          data: data
        })
    },
    testMakeOrderRequest () {
      const origin = {
        id: 1,
        name: 'ccs',
        items: [
          { id: 100, uuid: '----x', name: 'Apple', price: 100 },
          { id: 200, uuid: '----y', name: 'Orange', price: 150 }
        ]
      }
      const current = {
        id: 1,
        name: 'ccs',
        items: [
          { id: 100, uuid: '----x', name: 'Apple', price: 100 },
          { id: 200, uuid: '----y', name: 'Orange', price: 250 },
          { id: 300, uuid: '----z', name: 'Banana', price: 70 }
        ]
      }

      const changedData = compare.diff(origin, current)
      const checkObjectKey = 'items'
      const checkObject = common.getValueByPath(changedData, checkObjectKey)
      const getObjectKeys = ['uuid', 'id']

      /**
       * originalData, CurrentData, checkObject,...
       * check Object はいらないかも
       */

      // チェックオブジェクトから key を取得するところは外でやって、関数は内側にする
      if (checkObject) {
        for (let originalDataIndex of Object.keys(checkObject)) {
          const originalRecord = common.getValueByPath(common.getValueByPath(origin, checkObjectKey), originalDataIndex)
          // undefined の場合は delete をセット
          if (!changedData[checkObjectKey][originalDataIndex]) {
            changedData[checkObjectKey][originalDataIndex] = { delete: 1 }
          }
          for (let getObjectKey of getObjectKeys) {
            const originalProp = originalRecord ? originalRecord[getObjectKey] : null
            changedData[checkObjectKey][originalDataIndex][getObjectKey] = originalProp
          }
        }
      }
    }
  }
}
</script>
